import { Box, Typography } from '@mui/material';

import { Copyright } from './Copyright';
import { LinkWithDrawer } from './LinkWithDrawer';
import { ApprovedProviders } from '../ApprovedProviders';

export const FooterLinks = () => {
  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        justifyContent={{ xs: 'center', md: 'flex-start' }}
        gap={{
          xs: 1,
          md: '10px',
        }}
      >
        <LinkWithDrawer id="termsOfUse" />
        <Typography
          variant="body2"
          component="span"
          sx={{ fontWeight: '500', fontSize: { xs: 'inherit', md: '12px' } }}
        >
          •
        </Typography>
        <LinkWithDrawer id="privacyPolicy" />

        <LinkWithDrawer id="esignDisclosure" hideButton />
        <Box
          sx={{
            display: {
              xs: 'none',
              md: 'block',
            },
          }}
        >
          <Copyright />
        </Box>
        <ApprovedProviders />
      </Box>
      <Box
        sx={{
          display: {
            xs: 'flex',
            md: 'none',
          },
          justifyContent: 'center',
        }}
      >
        <Copyright />
      </Box>
    </>
  );
};
